import { render } from "./IsSellingTag.vue?vue&type=template&id=04cc3bbd"
import script from "./IsSellingTag.vue?vue&type=script&lang=js"
export * from "./IsSellingTag.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__